import analyticsSaga from './analyticsSaga';

export default analyticsSaga;
